import i18n from 'i18n-js';

export const renderTime = ({ h, m, s }: { h: string; m: string; s: string }) => {
  const hN = Number(h);
  const mN = Number(m);
  const sN = Number(s);

  const seconds = sN > 0 ? ` ${sN}${i18n.t('s')}` : '';

  if (hN > 0) {
    return `${hN}${i18n.t('h')} ${mN}${i18n.t('m')}${seconds}`;
  }
  if (mN > 0) {
    return `${mN}${i18n.t('m')}${seconds}`;
  }

  return `${sN}${i18n.t('s')}`;
};
